import * as React from 'react'
import * as classnames from 'classnames'

import { StoreComponent, injectStores } from '../../../store'
import * as styles from './introplayer.css'

import posed from 'react-pose'

import { observer } from 'mobx-react'

import { bind } from 'bind-decorator'
import { observable, computed } from 'mobx'
import { CloseButtonYellow } from '../../common/elements/buttons'
import { ContentChapter, ContentSubTopic } from '../storydocStoreContent'
import { BackgroundVideo } from '../../common/video/backgroundVideo'

interface IProps {
  onCloseClick: () => void
  active?: boolean
  chapter: ContentChapter | ContentSubTopic
  isBg?: boolean
  className?: string
}

@injectStores
@observer
export class IntroPlayer extends StoreComponent<IProps> {
  @observable forcePlay = false
  @observable play = true

  @computed
  get isCordova () {
    return window.hasOwnProperty('cordova')
  }

  render () {
    // console.log(this.props)
    const videoProps = {
      open: { scale: 0.9, transition: { duration: this.isCordova ? 0 : 1000, ease: 'easeOut' } },
      closed: { scale: 1, transition: { duration: this.isCordova ? 0 : 1000, ease: 'easeIn' } }
    }

    const AnimatedVideo = posed.div(videoProps)

    let player: JSX.Element | null = null

    const closeButton = (
      <CloseButtonYellow className={styles.closeButton} onClick={this.props.onCloseClick} />
    )

    const videoUrl = this.props.chapter instanceof ContentChapter ? this.props.chapter.urlIntroVideo : this.props.chapter.urlVideo

    if (this.props.chapter) {
      player = <BackgroundVideo
        videoUrl916={videoUrl}
        videoUrl169={videoUrl}
        active={this.props.active}
        isBg={this.props.isBg}
      />
    }

    return (
      <AnimatedVideo
        initialPose = 'closed'
        pose={this.props.isBg ? 'closed' : 'open'}
        className={classnames(this.props.className, styles.player, this.props.isBg ? styles.bgMode : null)}
        style={{ width: this.store.storeCommon.window.width / this.store.storeCommon.window.height > 4 / 3 && !this.props.isBg ? 1.33 * this.store.storeCommon.window.height : '100%' }}
      >
        {player}
        {!this.props.isBg && closeButton}
      </AnimatedVideo>
    )
  }

  @bind
  videoEnded () {
    this.forcePlay = false
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/introplayer/introplayer.tsx